import React from 'react';
import { Link, } from 'react-router';
import $ from 'jquery';
import Footer from './Layout/Footer/Footer';

const createReactClass = require('create-react-class');

const errorStyling = {
    maxWidth: '530px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
}
const ChangePassword = createReactClass({

  componentWillMount() {
    this.props.getCopyrightYear();
    $('#SCTitle').text("Reset Password | ShippingCart");
  },
  componentDidMount() {
    window.scrollTo(0, 0);
  },

  componentWillReceiveProps(nextProps) {
    if (nextProps.login.error && nextProps.login.error.response.status === 422) {

      if (nextProps.login.error.response.data.errors.detail === "User is archived.") {
        this.setState({ isArchived: true });
      } else if (nextProps.login.error.response.data.errors.detail === 'The new password field is required.') {
        this.setState({ invalidPassword: true });
      } else if (nextProps.login.error.response.data.errors.detail === 'Expired token.') {
        this.setState({ isExpired: true });
      } else if (nextProps.login.error.response.data.errors.detail === 'Expired token.') {
        this.setState({ isExpired: true });
      }else {
        this.setState({ defaultError: true });
      }
    }
  },

  getInitialState() {

    return {
      error: false,
      errorLength_newConfirmPassword: false,
      errorLength_newPassword: false,
      errorEmpty_newPassword: false,
      errorEmpty_newConfirmPassword: false,
      invalidPassword: false,
      isArchived: false,
      isExpired: false,
      defaultError: false,
    };

  },
  checkPasswordValidity(new_pass, confirm_pass) {
    let isValid = true;

    if (new_pass !== confirm_pass) {
      this.setState({ error: true, });
      isValid = false;
    } else {
      this.setState({ error: false, });
    }

    if (new_pass.length < 7 || new_pass === "" || confirm_pass === "") {
      this.setState({ errorLength_newPassword: true, });
      isValid = false;
    } else {
      this.setState({ errorLength_newPassword: false, });
    }

    if (confirm_pass.length === 0) {
      this.setState({ errorEmpty_newConfirmPassword: true, errorLength_newConfirmPassword: false, });
      isValid = false;
    } else {
      this.setState({ errorEmpty_newConfirmPassword: false, });
    }

    return isValid;
  },
  handleSubmit(e) {
    e.preventDefault();

    this.setState({ error: false, invalidPassword: false, isArchived: false, defaultError: false, isExpired: false, errorLength_newPassword: false });

    var new_password = this.refs.new_password.value;
    var new_confirm_password = this.refs.new_confirm_password.value;
    const token = this.props.location.query.token;
    const email = this.props.location.query.email;

    if (this.checkPasswordValidity(new_password, new_confirm_password)) {
      this.props.changePassword(new_password, new_confirm_password, email, token);
    }

    // new_password !== new_confirm_password || new_password === "" || new_confirm_password === "" ?
    //   this.setState({ error: true, }) : this.setState({ error: false, });

    // new_password.length < 6 ?
    //   this.setState({ errorLength_newPassword: true, }) : this.setState({ errorLength_newPassword: false, });

    // new_confirm_password.length < 6 ?
    //   this.setState({ errorLength_newConfirmPassword: true, }) : this.setState({ errorLength_newConfirmPassword: false, });

    // new_password.length === 0 ?
    //   this.setState({ errorEmpty_newPassword: true, errorLength_newPassword: false, error: false, }) : this.setState({ errorEmpty_newPassword: false, });

    // new_confirm_password.length === 0 ?
    //   this.setState({ errorEmpty_newConfirmPassword: true, errorLength_newConfirmPassword: false, }) : this.setState({ errorEmpty_newConfirmPassword: false, });

    // this.props.changePassword(new_password, new_confirm_password, email, token);

  },

  handleWidget(e) {
    e.preventDefault();
    window.FreshWidget.show();
  },

  handleShowPassword(e) {
    const name = e.target.name;
    if (this.refs['show_' + name].checked) {
      this.refs[name].type = 'text';
    } else {
      this.refs[name].type = 'password';
    }
  },

  render() {
    return (

      <div>
        <div className="page-login header-minimal-head">
          <header className="site-header header-minimal">
            <div className="container">
              <div className="logo">
                <Link to="/" className="clearfix">
                  <div className="main-img"></div>
                </Link>
              </div>
              <nav className="top-nav">
                <ul>

                </ul>
              </nav>
            </div>
          </header>
        </div>
        <div className="body-wrapper signinpage">
          <section className="container forgot">
            <div className="forgot-form">
              <form action="" method="POST">
                <div className="row clearfix">
                  <div className="pull-left">
                    <h1>Provide some info to <br /> reset your password</h1>
                  </div>

                  <div className="pull-right back">
                    <Link to="/home"> &#60; Back to home</Link>
                  </div>
                </div>

                <div className="instructions">
                  <p>Make sure to pick a clever and unforgettable password!</p>
                </div>

                {this.state.error ? <div className="notify">
                  <div className="sc-alert sc-alert-danger"><i className="sc" /> {this.props.login.error.response && this.props.login.error.response.data.errors.length ? 'Invalid input' :  'Make sure your passwords match.'}</div>
                </div> : null}
                

                {this.state.errorLength_newPassword && !this.state.error ? <div className="notify">
                  <div className="sc-alert sc-alert-danger" 
                    style={ errorStyling }
                  ><i className="sc" style={{ width: '33px' }} />Password must be at least 7 characters long and should contain a combination of uppercase, lowercase, numeric, and special characters.</div>
                </div> : null}

                {this.state.invalidPassword ? <div className="notify">
                  <div className="sc-alert sc-alert-danger"><i className="sc" /> Update Failed. Please enter a valid password</div>
                </div> : null}

                {this.state.isArchived ? <div className="notify">
                  <div className="sc-alert sc-alert-danger"><i className="sc" />
                    This account has been archived. To activate it, <a onClick={this.handleWidget}>contact</a> ShippingCart Customer Care.
                  </div>
                </div> : null}

                {this.state.isExpired ? <div className="notify">
                  <div className="sc-alert sc-alert-danger"><i className="sc" />Change password request has expired.</div>
                </div> : null}

                {this.state.defaultError ? <div className="notify">
                  <div className="sc-alert sc-alert-danger" style={errorStyling}>
                    <i className="sc" />
                    {this.props.login.error.response.data.errors.detail ? <p style={{ maxWidth: 'inherit', marginBottom: '0px'}}>{this.props.login.error.response.data.errors.detail}</p> : this.props.login.error.response.data.errors.map(({detail})=> (<p style={{ maxWidth: '456px', marginBottom: '0px'}}>{detail}</p>)) }
                  </div>
                </div> : null}

                <div className="form-group ">

                  <label className="control-label"> New Password &nbsp;
                  </label>
                  <div className="input-group" style={{ marginTop: '10px' }}>
                    <input type="password" ref="new_password" className={this.state.defaultError || this.state.error || this.state.errorLength_newPassword ? "form-control error-input" : "form-control"}
                      name="password" defaultValue="" autoFocus />
                    <div className="input-group-addon">
                      <div className="checkbox checkbox_nomargin">
                        <input
                          id="show_new_password"
                          name="new_password"
                          type="checkbox"
                          ref="show_new_password"
                          onClick={(e) => this.handleShowPassword(e)}
                        />
                        <label htmlFor="show_new_password">SHOW</label>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="form-group ">


                  <label className="control-label">Re-enter password &nbsp;
                  </label>
                  <div className="input-group">
                    <input type="password" ref="new_confirm_password" className={this.state.defaultError || this.state.error || this.state.errorEmpty_newPassword || this.state.errorLength_newPassword ? "form-control error-input" : "form-control"}
                      name="confirm_password" defaultValue="" />
                    <div className="input-group-addon">
                      <div className="checkbox checkbox_nomargin">
                        <input
                          id="show_new_confirm_password"
                          name="new_confirm_password"
                          type="checkbox"
                          ref="show_new_confirm_password"
                          onClick={(e) => this.handleShowPassword(e)}
                        />
                        <label htmlFor="show_new_confirm_password">SHOW</label>
                      </div>
                    </div>
                  </div>
                </div>

                <div>
                  <div className="login-btn">
                    <input type="hidden" />
                    <button type="submit" className="btn align-right btn-orange" onClick={this.handleSubmit}>Set new password</button>
                  </div>
                </div>
              </form>
            </div>
          </section>
          <section className="shadow"></section>
        </div>

        <Footer currentPath={this.props.location.pathname} currentYear={this.props.login.year} />
      </div>





    )


  },




});

export default ChangePassword;



/** WEBPACK FOOTER **
 ** ./src/components/ChangePassword.js
 **/